import React from 'react';
import PropTypes from 'prop-types';

const Image = ({src, alt, className, type, useLazy}) => {

				return (
					<div className={`image ${className || ""} ${type || ""}`}>
						{useLazy ?
							<img className={"lazyload"} data-src={src} alt={alt} title={alt} />
							: <img src={src} alt={alt} title={alt} />
						}
					</div>
				)

};

Image.propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string,
	className: PropTypes.string,
	useLazy: PropTypes.string
};

export default Image;
